import React, { useEffect, useState } from 'react';
import Loader from 'src/shared/components/loader/Loader';
import ErrorScreen from 'src/shared/components/error-screen/ErrorScreen';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import { useCustomersQuery } from 'src/app/customers/state/api/customersGraphSlice';
import { rtkQueryErrorToError } from 'src/shared/utils/errorHelpers';
import loginStorageService from '../../services/login-storage-service';

const PostAuthRedirect = () => {
    const navigate = useAppNavigation();
    const [navigationError, setNavigationError] = useState<Error>();
    const {
        currentData: allCustomers,
        isLoading: isLoadingCustomers,
        isError: isCustomersQueryError,
        error: customersQueryError,
    } = useCustomersQuery({});

    useEffect(() => {
        const handleRedirect = async () => {
            try {
                // Stored redirect does not depend on customers — avoid an infinite loader if the query fails
                const redirectTo = loginStorageService.getRedirectPath();
                if (redirectTo) {
                    loginStorageService.clearRedirectPath();
                    window.location.assign(decodeURIComponent(redirectTo));
                    return;
                }

                if (isLoadingCustomers && !allCustomers) {
                    return;
                }

                if (isCustomersQueryError && !allCustomers) {
                    return;
                }

                if (allCustomers?.customers && allCustomers.customers.length > 0) {
                    const nonDemoPortfolioCustomer = allCustomers.customers.find(
                        customer => customer.customerId !== 'Extractives Customer' && customer.hasPortfolio
                    );

                    if (nonDemoPortfolioCustomer) {
                        navigate.toPortfolioSummary(nonDemoPortfolioCustomer.customerId);
                        return;
                    }
                }

                navigate.toProjects();
            } catch (err) {
                setNavigationError(err as Error);
            }
        };

        void handleRedirect();
    }, [allCustomers, isLoadingCustomers, isCustomersQueryError, navigate]);

    if (isCustomersQueryError && !allCustomers) {
        return <ErrorScreen error={rtkQueryErrorToError(customersQueryError, 'Failed to load your account. Please try again.')} />;
    }

    if (navigationError) {
        return <ErrorScreen error={navigationError} />;
    }

    return <Loader />;
};

export default PostAuthRedirect;
